import { render, staticRenderFns } from "./popper-view.vue?vue&type=template&id=16294005"
import script from "./popper-view.vue?vue&type=script&lang=js"
export * from "./popper-view.vue?vue&type=script&lang=js"
import style0 from "./popper-view.vue?vue&type=style&index=0&id=16294005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports